/** True when the API-reported environment should be treated as production. */
export function isProductionEnvironment(name: string): boolean {
  const n = name.trim().toLowerCase();
  return n === "prod" || n === "production";
}
